// extracted by mini-css-extract-plugin
export var dateLabel = "_30-0";
export var dateLabelError = "_30-1";
export var fullWidth = "_30-2";
export var smaller = "_30-3";